// Panel bildirimleri (zil) — ortak sabitler ve yardımcılar.
// Contract: BayinerIOT-Workspace-/docs/api-contracts/tasks.md → "Bildirimler (1.2)"
// + manual-quota-qr.md §6 (manuel kota talebi, bayi zili — #115)
import {
  FiUserPlus,
  FiMessageSquare,
  FiRefreshCw,
  FiClock,
  FiAlertTriangle,
  FiBell,
  FiHash,
} from "react-icons/fi";

export const NOTIFICATION_LIMIT = 20;
export const UNREAD_POLL_MS = 60000;

// Tip → ikon + renk (Tailwind sınıfları literal — purge korusun).
export const NOTIFICATION_TYPES = {
  task_assigned: { icon: FiUserPlus, className: "bg-indigo-50 text-indigo-600" },
  task_commented: { icon: FiMessageSquare, className: "bg-sky-50 text-sky-600" },
  task_status_changed: { icon: FiRefreshCw, className: "bg-emerald-50 text-emerald-600" },
  task_due_soon: { icon: FiClock, className: "bg-amber-50 text-amber-600" },
  task_overdue: { icon: FiAlertTriangle, className: "bg-red-50 text-fifth" },
  manual_quota_request: { icon: FiHash, className: "bg-amber-50 text-amber-600" },
};
const FALLBACK_TYPE = { icon: FiBell, className: "bg-gray-100 text-gray-500" };
export const getNotificationType = (type) => NOTIFICATION_TYPES[type] || FALLBACK_TYPE;

export const formatBadge = (count) => {
  const n = Number(count) || 0;
  if (n <= 0) return "";
  return n > 99 ? "99+" : String(n);
};

export const taskPath = (key) => `/Anasayfa/IsPlanlama?is=${encodeURIComponent(key)}`;

// Cihaz bilgi ekranı (zil yalnız merkezde — #178).
export const devicePath = (scope, deviceId) => `/Anasayfa/Cihazlar/${deviceId}`;

// Server zinciri:
//   merkez: restrictTo("admin", "storage") → tasks.access VEYA devices.quota
// Bayide zil YOK — bayi manuel kota yükleyemez, bildirim almaz (#178).
const STORAGE_ROLES = ["admin", "storage"];
export const notificationScope = () => "storage";
export const canUseNotifications = (role, hasPermission) => {
  return (
    STORAGE_ROLES.includes(role) &&
    (!!hasPermission?.("tasks.access") || !!hasPermission?.("devices.quota"))
  );
};

// Server socket kapısı: admin dışındakiler için `dashboard.read` VEYA `devices.settings` VEYA `devices.maintenance` (#235) şart
// (infra/socket/socket.events.js). Yalnız `tasks.access` olan kullanıcı reddedilir → socket hiç
// açılmaz, zil 60 sn'de bir `unreadCount` sorgular. Server listeye birebir bakar (client'taki
// storage-management wildcard'ı socket'te geçerli değil) — o yüzden izin dizisi doğrudan kontrol edilir.
export const canUseNotificationSocket = (role, permissions = []) =>
  role === "admin" ||
  permissions.includes("dashboard.read") ||
  permissions.includes("devices.settings") ||
  permissions.includes("devices.maintenance");
